import { IGetClientInfoService } from "@modules/orders/models/IGetClientInfoService";
import { safeExecute } from "@utils/safeExecute";

export function fetchCustomerData(
  service: IGetClientInfoService,
  cnpj: string
) {
  return safeExecute(
    () => service.execute(cnpj, true),
    "Ocorreu um erro ao buscar dados do cliente"
  );
}
